import React, { Component } from 'react';
import { getHtmlRootOrBodyFromDOM, elementLoadCheck, $qs, getWindowHeightSize } from '../../helpers/misc-javascript-helpers';
import './scroll-progress.css';

class ScrollProgress extends Component {

    constructor(props) {
        super(props);

        this.state = {
            visibilityThrottle: this.props.visiThrottle, // milliseconds
            scrollProgressVal: 0,
            scrollProgressBar: true,
            scrollIndicator: false,
            show: true
        };
        /* Instance Variables */
        this.bodyElement;
        this.bodyElementHeight = 0;
        this.activateClass = false;
        this.captureCurrentTime = false;
        this.checkingStatus = false;
        this.dateTimeCheck;
        this.htmlSrcElement;
        this.startingScrollTop;
        this.scrollIndicator;
        this.scrollProgressVal = 0;
        this.scrollProgressPercentage = 0;
        this.scrollProgressBar;
        this.scrollingStatus = false;
        this.startedClock = false;
        /* BINDINGS */
        this.handleProgressBar = this.handleProgressBar.bind(this);
       
    }

    componentDidMount() {
        /* Check UserAgent for appropriate DOM access to the HTML/BODY element for scrollTop */
        this.htmlSrcElement = getHtmlRootOrBodyFromDOM();
        if (typeof this.htmlSrcElement !== 'undefined' && typeof this.htmlSrcElement !== '') {
            window.addEventListener('scroll', this.handleProgressBar);
            window.addEventListener('load', this.handleProgressBar);
            this.bodyElement = elementLoadCheck('body') ? $qs('body') : '';
            this.scrollIndicator = elementLoadCheck('.scroll-progress__indicator') ? $qs('.scroll-progress__indicator') : '';
            this.scrollProgressBar = elementLoadCheck('.scroll-progress__bar') ? $qs('.scroll-progress__bar') : '';
        }
    }

    /** Get the scrollTop value for the document/body/html. */
    getScrollTop() {
        return this.htmlSrcElement.scrollTop;
    }

    /** Set the scrollTop value for the document/body/html.  */
    setScrollTop(value) {
        this.htmlSrcElement.scrollTop = value;
    }

    /** Access the scrollTop value for use in the progress bar through startingScrollTop. */
    handleScrollTop() {
        this.startingScrollTop = this.getScrollTop();
        return this.startingScrollTop;
    }

    /** 
     * Update the body height for the page after the elements have loaded if height expansion
     * causes the document to adjust its scroll min, max, and/ or current value. 
     */
    handleBodyHeight(e) {
        if (this.htmlSrcElement.offsetHeight > 0 && this.htmlSrcElement.offsetHeight !== this.bodyElementHeight) {
            this.bodyElementHeight = this.htmlSrcElement.offsetHeight;
        }else{
            this.bodyElementHeight = this.bodyElementHeight;
        }
        return this.bodyElementHeight;
    }

    /** Calculate the Progress Bar numerical value */
    calculateProgressValue() {
        this.scrollProgressVal = this.startingScrollTop / (this.bodyElementHeight - getWindowHeightSize());
        return this.scrollProgressVal;
    }

    /** Calculate the Progress Bar percentage Value => 'integer' or 'float'. */
    calculateProgressPercentage(numberType) {
        if (numberType === 'integer') {
            this.scrollProgressPercentage = Math.round(this.calculateProgressValue().toPrecision(2) * 100);
        } else {
            this.scrollProgressPercentage = this.calculateProgressValue().toPrecision(3) * 100.0;
        }
        return this.scrollProgressPercentage;
    }

    /** Check the scolling status against *time and toggle the visibility. */
    handleVisibilityToggle() {
        this.scrollingStatus = true;
        if (this.scrollingStatus && !this.startedClock) {
            this.dateTimeValue = Date.now();
            this.startedClock = true;
        }

        const timeDiff = this.getTimeDiffValue(this.dateTimeValue);
        this.handleTimeDiffCheck(timeDiff);
        this.conditionTimedDeactivation();
    }

    conditionTimedDeactivation() {
        if (this.activateClass && this.checkingStatus) {
            const latestScrollVal = this.getScrollTop();
            /* Did the user stop scrolling??? */
            setTimeout(() => {
                /* Take a peek... */
                this.handleScrollOnTimeOut(latestScrollVal);
            }, this.state.visibilityThrottle);
        }
    }

    /** Hides the scroll bar, resets status booleans, and clears the dateTime value */
    handleScrollOnTimeOut(lastScrollVal) {
        const checkScrollOnTimeout = this.getScrollTop();
        if (checkScrollOnTimeout === lastScrollVal) {
            /* If scrollTop didn't change => stop doing everything... */
            this.setState({ scrollProgressBar: false });
            this.setState({ scrollIndicator: false });
            this.scrollingStatus = false;
            this.checkingStatus = false;
            this.activateClass = false;
            this.dateTimeValue = null;
            setTimeout(() => {
                /* Hide... */
                this.setState({show: false});
            }, 100);
        }
        return {
            progressBar: this.state.scrollProgressBar,
            scrollIndicator: this.state.scrollIndicator,
            checkingStatus: this.checkingStatus, 
            activateClass: this.activateClass,
            dateTimeValue: this.dateTimeValue
        };
    }

    /** Calculate the time difference between NOW and the provided value. */
    getTimeDiffValue(dateTimeVal) {
        return (Date.now() - dateTimeVal);
    }

    handleTimeDiffCheck(timeDifference) {
        if (this.startedClock && timeDifference > this.state.visibilityThrottle && !this.activateClass) {
            this.setState({ scrollProgressBar: true });
            this.setState({ scrollIndicator: true });
            this.setState({show: true});
            /* Declaring that a scroll status check is in progress - between 0 to number of
            milliseconds assigned to visibilityThrottle state */
            this.checkingStatus = true;
            this.activateClass = true;
            this.startedClock = false; // reset the process.
        }
        return {
            progressBar: this.state.scrollProgressBar,
            scrollIndicator: this.state.scrollIndicator,
            checkingStatus: this.checkingStatus, 
            activateClass: this.activateClass,
        };
    }

    /** Orchestrates and exectues the progress bar feature => onscroll. */
    handleProgressBar() {
        this.handleScrollTop();
        this.handleBodyHeight();
        const progressValueFloat = this.calculateProgressPercentage('float');
        const progressValueInteger = this.calculateProgressPercentage('integer');

       // this.handleVisibilityToggle();
        this.scrollIndicator.innerHTML = progressValueInteger ? progressValueInteger + '%' : '0%';
        this.scrollProgressBar.style.width = progressValueFloat ? progressValueFloat + '%' : '0%';
        this.setState({scrollProgressVal: progressValueFloat ? progressValueFloat.toPrecision(2) : 0});
        this.scrollingStatus = true;
    }

    render() {
        const styleBar = this.state.show ? {display: 'block', width: '0%'} : {display: 'none'};
        return (
            <div className="scroll-progress__block">
                <div className={this.state.scrollProgressBar ?  'scroll-progress__bar active' : 'scroll-progress__bar'} tabIndex="0" aria-label="progressbar" style={styleBar} role="progressbar" max="100" min="0" 
                value={this.state.scrollProgressVal} aria-valuenow={this.state.scrollProgressVal} aria-valuemin="0" aria-valuemax="100">
                    <div className={this.state.scrollIndicator ? 'scroll-progress__indicator active' : 'scroll-progress__indicator'}></div>
                </div>
            </div>
        );
    }
}

export default ScrollProgress;